import React, { useState, useEffect } from 'react'
import styled, { keyframes, css } from 'styled-components'
import colors from '../../styles/colors'

// Animation pour faire entrer un paragraphe en scroll-up
const scrollUpIn = keyframes`
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

// Animation pour faire sortir un paragraphe en scroll-up
const scrollUpOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
`

// Styled-component pour le paragraphe avec des styles conditionnels en fonction de l'état (entrée/sortie)
const StyledParagraph = styled.p`
    font-size: 18px;
    margin: 20px 0;
    text-align: center;

    ${(props) =>
        props.$isVisible
            ? css`
                  animation: ${scrollUpIn} 1s forwards; /* Apparition */
              `
            : css`
                  animation: ${scrollUpOut} 1s forwards; /* Disparition */
              `}
`

// Conteneur global
const ParagraphsContainer = styled.div`
    padding: 20px;
    height: 250px; /* Limiter la hauteur pour mieux voir l'effet */
    overflow: hidden; /* Masquer les paragraphes qui sortent */
    display: flex;
    width: 80%;
    display: flex;
    justify-content: center;

    a {
        text-decoration: none;
        font-size: 20px;
        color: ${colors.forth};
    }
`

const Statistics = () => {
    // Liste des paragraphes en texte brut
    const paragraphs = [
        <a href="https://foodwaste.ch/fr/que-signifie-le-food-waste/">
            <i>
                "Chaque ménage suisse jette en moyenne des aliments d'une valeur
                d'environ 620 CHF par an."
            </i>
            <br />- FoodWaste.ch
        </a>,
        <a href="https://www.admin.ch/gov/fr/accueil/documentation/communiques.msg-id-87910.html">
            <i>
                "Un tiers des aliments produits pour la consommation suisse sont
                gaspillés, soit environ 330 kg de déchets par habitant et par
                an."
            </i>
            <br />- Office Fédéral de l'Environnement
        </a>,
        <a href="https://www.wwf.ch/fr/nos-objectifs/gaspillage-alimentaire">
            <i>
                "Le gaspillage alimentaire représente environ 25 % des émissions
                de gaz à effet de serre liées à l'alimentation en Suisse."
            </i>
            <br />- WWF Schweiz​
        </a>,
        <a href="https://org.biosuisse.ch/konsumenten/fr/vivre-bio-suisse/blog/posts/2021/05/food-waste.html">
            <i>
                "Le système alimentaire représente environ 28 % de l’empreinte
                totale de la Suisse, dont un quart provient des pertes
                alimentaires évitables."
            </i>
            <br />- Office Fédéral de l'Environnement
        </a>,
    ]

    const [visibleParagraphIndex, setVisibleParagraphIndex] = useState(0)
    const [isVisible, setIsVisible] = useState(true)

    useEffect(() => {
        const interval = setInterval(() => {
            setIsVisible(false) // Commencer la disparition

            setTimeout(() => {
                // Changer le paragraphe après la fin de l'animation de disparition
                setVisibleParagraphIndex(
                    (prevIndex) => (prevIndex + 1) % paragraphs.length
                )
                setIsVisible(true) // Commencer l'apparition du nouveau paragraphe
            }, 1500) // correspond à la durée de l'animation de disparition
        }, 6000) //

        return () => clearInterval(interval) // Nettoyage de l'intervalle
    }, [paragraphs.length])

    return (
        <ParagraphsContainer>
            {/* Afficher seulement le texte actif */}
            <StyledParagraph $isVisible={isVisible}>
                {paragraphs[visibleParagraphIndex]}
            </StyledParagraph>
        </ParagraphsContainer>
    )
}

export default Statistics
